// extracted by mini-css-extract-plugin
export default {"root":"MilestonesSummary_root__2Sksd","wrapper":"MilestonesSummary_wrapper__lZdkk"};